// TODO: pre process / generate static files / lazy load translations variables
import common from '@webapp-next/modules/common/locales/en.json'; // TODO: move, move the translation file to the right place
import people from '@webapp-next/modules/people/locales/en.js'; // TODO: get translations from each module automagically
import profile from '@webapp-next/modules/profile/locales/en.json'; // TODO: get translations from each module automagically
import me from '@webapp-next/modules/me/locales/en.json';
import meOnboarding from '@webapp-next/modules/me-onboarding/locales/en.json';
import newsfeed from '@webapp-next/modules/newsfeed/locales/en.json';
import globalSettings from '@webapp-next/modules/global-settings/locales/en.json';
import enterprise from '@webapp-next/modules/enterprise/locales/en.json';
import helpCenter from '@webapp-next/modules/help-center/locales/en.json';
import integrations from '@webapp-next/modules/integrations/locales/en.json';
import integrationsConnect from '@webapp-next/modules/integrations-connect/locales/en.json';
import locations from '@webapp-next/modules/locations/locales/en.json';
import schedule from '@webapp-next/modules/schedule/locales/en.json';
import trialOnboarding from '@webapp-next/modules/trial-onboarding/locales/en.json';
import inviteYourself from '@webapp-next/modules/invite-yourself/locales/en.json';
import reports from '@webapp-next/modules/reports/locales/en.json';
import awards from '@webapp-next/modules/awards/locales/en.json';
import leave from '@webapp-next/modules/leave/locales/en.json';
import appLeave from '@apps/leave/src/locales/en-combined';
import hire from '@webapp-next/modules/hire/locales/en.json';
import appHire from '@apps/hire/src/locales/en-combined';
import appCulture from '@apps-culture/locales/en-combined.ts';
import locationsSetup from '@webapp-next/modules/locations-setup/locales/en.json';
import components from '@webapp-next/components/locales/en.json';
import oauth from '@webapp-next/modules/oauth/locales/en.json';
import appHr from '@apps/hr/src/locales/en-combined';
import scheduleShiftConfirm from '@/modules/schedule-shift-confirm/locales/en.json';
import scheduleShiftAccept from '@/modules/schedule-shift-accept/locales/en.json';
import appOnce from '@apps/once/src/locales/en.json';
import appShared from '@apps/billing-shared/src/locales/en.json';
import appHomeDashboard from '@apps/home-dashboard/src/locales/en.json';
import appReports from '@/apps/reports/src/locales/en.json';
import appPayroll from '@/apps/payroll/src/locales/en-combined';
import appLocations from '@apps/locations/src/locales/en.json';
import appLegacyReports from '@apps/legacy-reports/src/locales/en.json';
import appEmployeeManagement from '@apps/employee-management/src/locales/en-combined';
import availability from '@/modules/availability/locales/en.json';
import headMeDropdown from '@webapp-next/modules/head-me-dropdown/locales/en.json';
import billingTenant from '@webapp-next/modules/billing-tenant/locales/en.json';
import aiAssistant from '@webapp-next/modules/ai-assistant/locales/en.json';

import mobileWebWelcome from '@webapp-next/modules/mobile-web-welcome/locales/en.json';
// TODO: get translations from each module automagically
const combined = {
  ...common,
  ...people,
  ...profile,
  ...me,
  ...meOnboarding,
  ...newsfeed,
  ...globalSettings,
  ...enterprise,
  ...helpCenter,
  ...integrations,
  ...integrationsConnect,
  ...locations,
  ...schedule,
  ...trialOnboarding,
  ...inviteYourself,
  ...reports,
  ...awards,
  ...mobileWebWelcome,
  ...leave,
  ...hire,
  ...locationsSetup,
  ...components,
  ...oauth,
  ...appHr,
  ...scheduleShiftConfirm,
  ...scheduleShiftAccept,
  ...appOnce,
  ...appShared,
  ...appHomeDashboard,
  ...appLocations,
  ...appLegacyReports,
  ...availability,
  ...headMeDropdown,
  ...billingTenant,
  ...aiAssistant,
  apps: {
    leave: appLeave,
    hire: appHire,
    culture: appCulture,
    hr: appHr,
    reports: appReports,
    payroll: appPayroll,
    'employee-management': appEmployeeManagement,
  },
};

export default combined;
